import { AsyncPipe, NgIf } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlySelectOption, FormlySelectOptionsPipe } from '@ngx-formly/core/select';
import { TransformPipe } from '@core/pipes';

@Component({
  selector: 'kt-preview-selection',
  templateUrl: './preview.component.html',
  styles: [
    `
      .label {
        color: #3f51b5;
        text-wrap: nowrap;
      }
    `,
  ],
  imports: [AsyncPipe, FormlySelectOptionsPipe, MatChipsModule, MatIconModule, NgIf, TransformPipe],
})
export class PreviewSelectionComponent {
  readonly field = input.required<FormlyFieldConfig>();
  readonly showPreview = input<boolean>(false);
  readonly canRemove = input<boolean>(false);
  readonly shorten = input<boolean>(true);
  readonly remove = output<any>();

  showSelected(value: unknown | unknown[], options: FormlySelectOption[], f: any): FormlySelectOption[] {
    if (value === undefined) {
      return [];
    }

    if (Array.isArray(value)) {
      return options?.filter(o => value.includes(o.value));
    }

    const opt = options.find(o => o.value === value);
    if (opt) {
      return [opt];
    }

    return [{ label: String(value), value: value as any }] as FormlySelectOption[];
  }
}
